import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Users from './_user/Users';
import Dashboard from '../../Dashboard';
import Orgcom from './_org/Orgcom';
import STSIndex from './_sts/STSIndex';
import BPIndex from './_bp/BPIndex';
import IndexRe from './_report/IndexRe';
import Profile from './_profile/Profile';
import ListRekeningBank from './_bank/ListRekeningBank';
import Report from './_report_admin/ReportIndex';
import IndexSetting from './setting/IndexSetting';


export default class AdminView extends React.Component {
   render() {
      return (
         <div>
            <Switch>
               <Route path={ "/a/dashboard" } name="dashboard" component={ Dashboard } />               
               <Route path={ "/a/users" } name="list-users" component={ Users } />
               <Route path={ "/a/bp" } name="bp" component={ BPIndex } />
               <Route path={ "/a/sts" } name="sts" component={ STSIndex } />
               <Route path={ "/a/org" } name="org" component={ Orgcom } />
               <Route path={"/a/bank"} name="bank" component={ListRekeningBank} />
               <Route path={ "/a/profile" } name="profile" component={ Profile } />
               <Route path={ "/a/re"} name="rencana-realisasi" component={ IndexRe } />
               <Route path={ "/a/report" } name="report" component={ Report } />
               <Route path={ "/a/setting" } name="setting" component={ IndexSetting } />
               <Redirect from="/a" to="/a/dashboard" />
            </Switch>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/admin.view.js